'use client';

import { defaultA11yLabel } from "./ActionMenu.data.js";
const defaultProps = {
  direction: "bottom",
  a11yLabel: defaultA11yLabel,
  emphasis: "medium",
  size: "sm"
};
export {
  defaultProps
};
